'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './page-edit.routes';

export class AdminPageEditComponent {
  constructor(DynamicPageService, Auth, $state, $stateParams, dialogs, StorageService, Upload, $q) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.StorageService = StorageService;
    this.Auth = Auth;
    this.Upload = Upload;
    this.$q = $q;

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h1","h2","h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["codeMirror"],
      ["archiveImageLink", "insertImage","insertLink","insertVideo"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.htmlEditorSetup = function ($element) {
      //$element.attr('ui-codemirror', '');
    };

    this.pageId = $stateParams.id;

    this.dialogs = dialogs;
    this.$state = $state;

    this.DynamicPageService.get({id: this.pageId}, data => {
      this.page = data;
    }, err => {
      console.log('Could not load dynamic page from server');
    })

    var that = this;

    this.dropHandler = function( file, insertAction ) {

      // validation
      if( !file.type.startsWith('image/') ) {
        // ignore other file than images
        return;
      }

      /* could check for file size: if( file.size > 500000 ) */

      var defer = that.$q.defer();

      that.Upload.upload({
        url: '/api/storage',
        data: {
          name: file.name,
          file: file,
          storageStrategy: 'local',
          creationUser: that.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then((response) => {
          insertAction( "insertImage", "/api/storage/" + response.data, true );
          defer.resolve(true);
      }, (response) => {
        if (response.status > 0) {
          alert(response.status + ': ' + response.data);
          defer.reject();
        }
      });

      return defer.promise;

    };
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The page has been changed successfully");
        dlg.result.then(() => {
          that.$state.go("admin-page-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.DynamicPageService.update({id: this.pageId}, this.page, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.adminPageEdit', [uiRouter])
  .config(routes)
  .component('adminPageEdit', {
    template: require('./page-edit.html'),
    controller: AdminPageEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/page/edit/page-edit.component.js